import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
export function Link({ children, className, variant = "cta", as, ...rest }) {
    const Component = as ?? "a";
    return (_jsx(Component, { ...rest, className: classNames("cvr-link", className, {
            "cvr-link--cta": variant.includes("cta"),
            "cvr-link--menu": variant.includes("menu"),
            "cvr-link--inline": variant.includes("inline"),
            "cvr-link--chip": variant.includes("chip"),
            "cvr-link--small": variant.includes("small"),
            "cvr-link--bold": variant.includes("bold"),
            "cvr-link--navigation": variant.includes("navigation"),
        }), children: children }));
}
